export const RERENDER_COMPONENT = 'ui/RERENDER_COMPONENT';

export default {
    RERENDER_COMPONENT,
};
